// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2xC8H","empty":"ModalGraph_empty__3OjGU"};